import { useCallback, useMemo } from "react";

export const useToggleHandlers = () => {
  const createToggleHandler = useCallback(
    (selectedItems, setSelectedItems, uniqueItems) => {
      return () => {
        if (selectedItems.length === uniqueItems.length) {
          setSelectedItems([]);
        } else {
          setSelectedItems([...uniqueItems]);
        }
      };
    },
    []
  );

  const createAlertTypeToggle = useCallback(
    (selectedAlertTypes, setSelectedAlertTypes, uniqueAlertTypes) => {
      return () => {
        const alertTypesExcept80 = uniqueAlertTypes.filter(
          (id) => String(id) !== "80"
        );
        const currentNon80Selected = selectedAlertTypes.filter(
          (id) => String(id) !== "80"
        );
        const has80Selected = selectedAlertTypes.some(
          (id) => String(id) === "80"
        );

        if (currentNon80Selected.length === alertTypesExcept80.length) {
          setSelectedAlertTypes(has80Selected ? ["80"] : []);
        } else {
          setSelectedAlertTypes(
            has80Selected ? [...alertTypesExcept80, "80"] : alertTypesExcept80
          );
        }
      };
    },
    []
  );

  return { createToggleHandler, createAlertTypeToggle };
};
